export default __webpack_public_path__ + "static/media/error-upload.8204f1ac.svg";